import { render, staticRenderFns } from "./list.vue?vue&type=template&id=f2fd2d6c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=f2fd2d6c&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=f2fd2d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fd2d6c",
  null
  
)

export default component.exports